import React from 'react';
import { PricingSection } from '../components/PricingSection';
import { CTASection } from '../components/CTASection';
export const PricingPage = () => {
  return <div className="pt-8" data-id="element-285">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mb-12" data-id="element-286">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-287">
          Plans & Pricing
        </h1>
        <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto" data-id="element-288">
          Transparent pricing designed to scale with your hiring needs.
        </p>
      </div>
      <PricingSection data-id="element-289" />
      <CTASection data-id="element-290" />
    </div>;
};